<template>
  <modal :show="show">
    <div slot="modalHeader">
      <modal-header :closeModal="closeModal">Preview or Review Link {{ isClone ? '(from duplicate action)' : '' }}</modal-header>
    </div>
    <div class="create-preview-link">
      <div class="form-group row">
        <label for="link_title" class="col-sm-4 col-form-label">Set link title </label>
        <field
            id="link_title"
            class="col-sm-12"
            :type="'text'"
            v-model="model.linkTitle"
        />
        <br>
        <small style="padding-left: 2rem">
          Add a descriptive title for your shared link
        </small>
      </div>
      <div class="form-group row" v-if="!this.isClone">
        <checkbox
            id="review_comment"
            class="col-sm-1"
            style="padding-left: 3rem;"
            :type="'text'"
            @input="requestReviewHandler"
            v-model="model.sendToReview"
        />
        <label for="review_comment" class="col-form-label">Send a review and comment link</label>
      </div>
      <div class="form-group row create-preview-link__form-control">
        <label class="col-sm-4 col-form-label">Password {{model.sendToReview ? '(required)' : '(optional)'}} </label>
      </div>
      <div class="form-group row">
        <checkbox
            v-if="!model.sendToReview"
            id="password"
            class="col-sm-1"
            style="padding-left: 3rem; margin-top: 0.5rem;"
            :type="'text'"
            @input="generatedPass"
            v-model="model.usePassword"
        />
        <field
            id="link_title"
            class=""
            :class="model.sendToReview ? 'col-sm-12' : 'col-sm-11'"
            :style="model.sendToReview ? '' : 'padding-left: unset'"
            :type="'text'"
            v-model="model.password"
        />
        <br>
        <small class="create-preview-link__password_info" v-if="model.sendToReview || model.usePassword">
          Auto generated password (Ammendable)
        </small>
        <br>
        <small class="create-preview-link__password_info" v-if="errors.password.has">
          {{errors.password.message}}
        </small>
      </div>
    </div>
    <div slot="modalFooter">
      <modal-footer confirmText="Proceed" :confirm="processGenerateLink" hideCancelText />
    </div>
  </modal>
</template>

<script>
import Modal from '@/components/Modal/modal'
import ModalHeader from '@/components/Modal/modal-header'
import ModalFooter from '@/components/Modal/modal-footer'
import ButtonCta from '@/components/Button/button'
import {modalMixin} from '@/mixins/modalMixin'
import {creativeMixin} from '@/mixins/creativeMixin'
import {notificationMixin} from '@/mixins/notificationMixin'
import Field from '@/components/Form/Field/field'
import Checkbox from '@/components/Form/Checkbox/checkbox'

const NOTIFICATION_DELAY = 15000

export default {
  name: 'modal_create_preview_link',
  mixins: [modalMixin, creativeMixin, notificationMixin],
  components: {
    Modal,
    ModalHeader,
    ModalFooter,
    ButtonCta,
    Field,
    Checkbox,
    notificationMixin
  },
  props: {
    show: Boolean,
    confirmId: String,
    creativeData: Object,
    selectedUnitsIds: Array,
    isClone: {type: Boolean, default: false},
    currentLinkName: {type: String, default: null}
  },
  data: () => ({
    errors: {
      password: {
        has: false,
        message: ''
      }
    },
    model: {
      linkTitle: '',
      sendToReview: false,
      usePassword: false,
      password: ''
    },
    creativeObjData: {}
  }),
  mounted () {
    const date = new Date()
    if (this.isClone) {
      this.model.linkTitle = this.currentLinkName
      this.model.sendToReview = true
      this.model.usePassword = true
      this.model.password = this.generatePassword()
    }
    this.creativeObjData = this.creativeData
    if (!this.isValid()) {
      this.close()
      return false
    }
    const creativeUnit = this.creativeData.data.creative
    this.model.linkTitle = `${creativeUnit.campaign.client.name} - ${creativeUnit.campaign.name} - ${creativeUnit.name} - ${date.getFullYear()}${date.getMonth() + 1}${date.getDay()}-${date.getTime()}`
  },
  computed: {
  },
  methods: {
    isValid () {
      if (!this.creativeData.data || this.selectedUnitsIds.length === 0) {
        const notification = this.addNotification('danger', 'Please select at least 1 unit to continue')
        setTimeout(() => {
          this.closeLastNotification(notification.id)
        }, NOTIFICATION_DELAY) // Wait 15 second to remove the notification
        return false
      }
      const selectedUnits = this.creativeData.data.units.filter(({id}) => this.selectedUnitsIds.includes(id))
      let hasErrors = false
      selectedUnits.every(({status}) => {
        if (status !== 'rendered') {
          hasErrors = true
          return false
        }
        return true
      })
      if (hasErrors) {
        const notification = this.addNotification('danger', 'Make sure to select only units with status Rendered')
        setTimeout(() => {
          this.closeLastNotification(notification.id)
        }, NOTIFICATION_DELAY) // Wait 15 second to remove the notification
        return false
      }
      return true
    },
    generatePassword () {
      const length = 8
      const charset = '0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ'
      let retVal = ''
      for (let i = 0, n = charset.length; i < length; ++i) {
        retVal += charset.charAt(Math.floor(Math.random() * n))
      }
      return retVal
    },
    closeModal () {
      this.isCopied = false
      this.close()
    },
    generatedPass (checked) {
      if (checked) {
        this.model.password = this.generatePassword()
      } else {
        this.model.password = ''
      }
    },
    processGenerateLink () {
      // decodeURIComponent(escape(window.atob( str )));
      if (this.model.password.trim().length < 8 && (this.model.sendToReview || this.model.usePassword)) {
        this.errors.password.has = true
        this.errors.password.message = 'Error: password required, at least 8 characters'
        setTimeout(() => {
          this.errors.password.false = true
          this.errors.password.message = ''
        }, 5000)
        return
      }
      this.$emit('actionChange', {
        currentTarget: {
          dataset: {
            id: this.creativeObjData.data.creative.hash_id,
            action: 'send-to-link',
            options: {...this.model, password: window.btoa(unescape(encodeURIComponent(this.model.password))), isClone: this.isClone},
            units: this.selectedUnitsIds
          }
        }
      })
      setTimeout(() => this.close(), 500)
    },
    requestReviewHandler (checked) {
      this.model.password = checked ? this.generatePassword() : ''
    }
  }
}

</script>

<style lang="scss">
.create-preview-link {
  padding-left: 15px;
  padding-right: 15px;

  &__password_info {
    margin-left: 5rem;
    color: #DC3545;
    font-weight: 700
  }

  &__form-control{
    margin-bottom: unset;
  }

  label{
    font-size: 12px;
    line-height: 15px;
  }
}
#copiedAlert {
  margin-top:15px;
}
</style>



// WEBPACK FOOTER //
// src/components/Modal/creatives/modal-create-preview-link.vue